import CreateApp from '@/components/create-app/create-app.vue';
import { mapGetters } from 'vuex';
import AppsApi from '../../api/apps-api/apps-api.service';

export default {
  name: 'AppList',
  components: {
    CreateApp,
  },
  computed: {
    ...mapGetters(['apps']),
    filteredApps() {
      return this.apps.filter(app => !this.searchQuery || app.prop('name').startsWith(this.searchQuery));
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  async mounted() {
    const apps = await AppsApi.getApps();
    this.$store.commit('SET_APPS', apps);
  },
  methods: {
    async deleteApp(app) {
      try {
        await app.delete();
        this.$store.commit('DELETE_APP', app);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
